import * as Yup from "yup";
import MESSAGE from "~/utils/messages";
import { isValid, parse, differenceInYears } from "date-fns";
import { cpfValidation } from "~/utils/tools";

export const schema = Yup.object().shape({
  DataNascimento: Yup.mixed()
    .required(MESSAGE.requiredField)
    .test({
      name: "birthDate",
      message: MESSAGE.invalidDate,
      test: (value) =>
        value &&
        isValid(parse(value, "dd/MM/yyyy", new Date())) &&
        parse(value, "dd/MM/yyyy", new Date()) >= new Date("01/01/1900"),
    })
    .test({
      name: "birthDate",
      message: MESSAGE.legallyYounger,
      test: (value) =>
        differenceInYears(new Date(), parse(value, "dd/MM/yyyy", new Date())) >=
        18,
    }),
  Documento: Yup.mixed()
    .required(MESSAGE.requiredField)
    .test({
      name: "cpf",
      message: MESSAGE.invalidCPF,
      test: (value) => value && cpfValidation(value),
    }),
});